import Typography from '@/common/components/base/typography/Typography';
import CardButton from '@/common/components/cardButton/CardButton';
import { Flex } from 'styled-system/jsx';
import DownloadIcon from '@/common/assets/icons/download.svg?react';
import FilesIcon from '@/common/assets/icons/files.svg?react';
import { token } from 'styled-system/tokens';
import { createZipFileQueryOptions } from '@/modules/FileDetail/queries/documentation/createZip/createZipFile/createZipFileQueryOptions';
import { downloadZipFileQueryOptions } from '@/modules/FileDetail/queries/documentation/downloadZip/downloadZipFile/downloadZipFileQueryOptions';
import useDownloadDocument from '@/modules/FileDetail/hooks/useDownloadDocument';
import { useParams } from 'react-router-dom';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';

const FileDocumentZip = () => {
  const { createZip, isPending } = useDownloadDocument({
    downloadOption: downloadZipFileQueryOptions,
    createOption: createZipFileQueryOptions,
  });
  const { id } = useParams();
  return (
    <CardButton
      title="زیپ مدارک"
      hasArrow={false}
      renderTag={() => (
        <Flex gap="3" alignItems="center">
          {isPending ? (
            <CircularLoading color="colors.purple-3" width="20px" />
          ) : (
            <DownloadIcon stroke={token('colors.purple-2')} />
          )}
          <Typography textStyle="b2" color="purple-2">
            دانلود
          </Typography>
        </Flex>
      )}
      cardProps={{
        boxShadow: 'none',
        onClick: () => {
          isPending ? undefined : createZip({ id: id! });
        },
      }}
      renderIcon={() => <FilesIcon />}
    />
  );
};
export default FileDocumentZip;
